// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3377 ? "2471753b" : chunkId) + "." + {"3377":"0f2861f9d3eff815","8257":"a19c4454ac5724cb"}[chunkId] + ".js";
};